<body id="body">
<app-loader *ngIf="isLoaderVisible"></app-loader>
<header>
  <div class="menu-container">
    <div class="navbar">
      <div class="logo clickable" [routerLink]="'/'">
        <img src="assets/other/logo_write.svg" alt="Lupul Creativ logo">
      </div>

      <div class="username flex">
        <p *ngIf="userName.length>0" class="italic"><mat-icon style="font-size: 14px; width: 16px">favorite</mat-icon>{{'welcome' | translate}}{{userName}}!</p>
      </div>

      <div class="menu" id="menu">

        <div class="burger-menu" [class.active]="active" (click)="onBurgerClicked()">
          <div class="burger-container">
            <div class="burger-inner"></div>
          </div>
        </div>

        <app-menu-popup *ngIf="active"></app-menu-popup>

      </div>
    </div>
  </div>
</header>

<div class="router-container">
  <router-outlet></router-outlet>
</div>

<div class="cookie" *ngIf="isCookieVisible">
  <p>🍪🍪 {{'weUseCookies' | translate}}</p>
  <p>{{'cookieText' | translate}}</p>
  <button mat-button (click)="acceptCookies()">{{'acceptCookie' | translate}}</button>
  <button mat-button (click)="refuseCookies()">{{'refuseCookie' | translate}}</button>
  <button mat-button (click)="redirect()">{{'knowMoreAboutCookie' | translate}}</button>
</div>

<footer class="footer footer-basic">
  <div class="book-divider">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
      <path d="M602.45,3.86h0S572.9,116.24,281.94,120H923C632,116.24,602.45,3.86,602.45,3.86Z" class="shape-fill"></path>
    </svg>
  </div>
  <div class="footer-info" >
    <div class="footer-info-cell">
      <img src="assets/logo/lupusor.png" class="logo" alt="Lupul Creativ logo">
    </div>
    <div class="footer-info-cell">
      <ul>
        <li>
          <a target="_blank" href="https://www.facebook.com/lupulcreativ" class="clickable">
            <img src="assets/other/facebook.svg" alt="facebook logo" class="social-media-links" >
          </a>
          <a target="_blank" href="https://www.instagram.com/lupulcreativ" class="clickable">
            <img src="assets/other/instagram.svg" alt="instagram logo" class="social-media-links">
          </a>
        </li>
        <li>lupulcreativ&#64;gmail.com</li>
        <li>+40 740 241 423</li>
        <li>
          <select name="language" (change)="changeLanguage($event.target)" [(ngModel)]="language">
            <option value="0">RO</option>
            <option value="1">EN</option>
          </select>
        </li>
      </ul>
    </div>
    <div class="footer-info-cell">
      <ul>
        <li>
          <a target="_blank" href="https://lupulcreativ.ro/#/TermsConditions" class="clickable">
            {{'termsAndConditionsAccount' | translate}}
          </a>
        </li>
        <li>
          <a target="_blank" href="https://lupulcreativ.ro/#/TermsConditions" class="clickable">
            {{'confidentialityPolicy' | translate}}
          </a>
        </li>
        <li>
          <a target="_blank" href="https://lupulcreativ.ro/#/TermsConditions" class="clickable">
            {{'cookiePolicyTitle' | translate}}
          </a>
        </li>
        <li>
          <a target="_blank" href="https://reclamatiisal.anpc.ro/" class="clickable">
            <img src="https://wpfitness.eu/wp-content/uploads/2022/10/anpc-sal.png" class="sal-sol" alt="anpc-sal">
          </a>
        </li>
        <li>
          <a target="_blank" href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" class="clickable">
            <img src="https://wpfitness.eu/wp-content/uploads/2022/10/anpc-sol.png" class="sal-sol" alt="anpc-sol">
          </a>
        </li>
      </ul>
    </div>
    <div class="footer-info-cell">
      <ul>
        <li>Lupul Creativ SRL</li>
        <li>CUI: 50083533</li>
        <li>J32/957/2024</li>
      </ul>
    </div>
  </div>
  <div class="line-divider"></div>
  <div class="last-line">
    <div class="copy-right">
      © Lupul Creativ - {{year}}
    </div>
    <div class="developed-by">
      Powered by <a target="_blank" href="https://scriptics.ro/" class="scr-link">Scriptics</a>
    </div>
  </div>
</footer>
</body>
